import React, { useEffect, useState } from 'react';
import { TransactionDetailsHeader } from '../TransactionDetailsHeader';
import { CategoryList } from './CategoryList';
import { SplitTrxModified } from './SplitTrxModified';
import { LiliTransaction } from '../../../types/lili-transaction';

interface IProps {
  transaction: LiliTransaction;
  onCategorySelect: (categoryId: string, businessPercent: number) => void;
}

export const CategorySplit = ({ transaction, onCategorySelect }: IProps) => {
  const [categoryId, setCategoryId] = useState<string>(transaction.categoryDetails?.categoryExternalId || '');

  useEffect(() => {
    setCategoryId(transaction.categoryDetails?.categoryExternalId || '');
  }, [transaction.transactionId]);

  const handleSaveNClose = (businessPercent: number) => {
    onCategorySelect(categoryId, businessPercent);
  };

  const handleTransactionSelect = (id: string) => {
    setCategoryId(id);
  };

  return (
    <div className='flex flex-col h-full'>
      <div className='mt-[20px]'>
        <TransactionDetailsHeader shouldHideBorder />
      </div>
      <CategoryList
        transaction={transaction}
        isInlineMode
        onCategorySelect={handleTransactionSelect}
        isDisabled={!categoryId}
      />
      <SplitTrxModified transaction={transaction} isDisabled={!categoryId} onSave={handleSaveNClose} />
    </div>
  );
};
